<template>
    <div class="print-activities">

        <button class="btn btn-primary" @click="showModal()">Print</button>

        <print-activities-modal v-if="modal.show"
                                :stage="stage"
                                :section="section"
                                :path="path"
                                @close="hideModal()" />

    </div>
</template>

<script>
import PrintActivitiesModal from "@/Components/LearningPath/PrintActivitiesModal";
import utils from '@/mixins/utils';
export default {
    name: "PrintActivities",
    components: {PrintActivitiesModal},
    mixins: [utils],

    props: ['stage', 'path', 'section'],

    data(){
        return {
            modal: {
                show: false,
            },

        }
    },

    methods: {
        showModal(){
            this.modal.show = true;
        },
        hideModal(){
            this.modal.show = false;
        }
    },

    mounted() {
    },

}
</script>

<style scoped>

</style>
